<template>
  <div class="cc-backdrop">
    <div class="cc-modal">
      <!-- Header -->
      <div class="cc-header">
        <h5 class="cc-title">Editar columnas</h5>
      </div>

      <!-- Body -->
      <div class="cc-body">
        <!-- Encabezados -->
        <div class="cc-row cc-row-header">
          <div class="cc-col-order">Orden</div>
          <div class="cc-col-label">Columna</div>
          <div class="cc-col-visible text-right">Visible</div>
          <div class="cc-col-export text-right">Exportar</div>
        </div>

        <!-- Lista scrollable -->
        <div class="cc-list">
          <draggable
            v-model="localColumns"
            item-key="key"
            handle=".cc-drag-handle"
            :animation="150"
          >
            <!-- vue-draggable-next usa el slot #item -->
            <template #item="{ element }">
              <div class="cc-row cc-row-item">
                <!-- Orden / drag handle -->
                <div class="cc-col-order">
                  <span class="cc-drag-handle">
                    <i class="fa fa-bars"></i>
                  </span>
                </div>

                <!-- Nombre de la columna -->
                <div class="cc-col-label">
                  <span class="cc-label-text">
                    {{ element.name }}
                  </span>
                </div>

                <!-- Switch visible -->
                <div class="cc-col-visible text-right">
                  <label class="cc-switch">
                    <input type="checkbox" v-model="element.visible" />
                    <span class="cc-slider"></span>
                  </label>
                </div>

                <div class="cc-col-export text-right">
                  <label class="cc-switch">
                    <input type="checkbox" v-model="element.export_visible" />
                    <span class="cc-slider"></span>
                  </label>
                </div>
              </div>
            </template>
          </draggable>
        </div>
      </div>

      <!-- Footer -->
      <div class="cc-footer">
        <button type="button" class="btn btn-outline-secondary" @click="onCancel">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" @click="onSave">
          Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "ColumnsConfigModal",
  components: { draggable },
  props: {
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localColumns: [],
    };
  },
  created() {
    this.localColumns = this.columns.map((c) => this.normalizeColumn(c));
  },
  watch: {
    columns: {
      handler(newVal) {
        this.localColumns = newVal.map((c) => this.normalizeColumn(c));
      },
      deep: true,
    },
  },
  methods: {
    toBoolean(value, fallback = false) {
      if (typeof value === "boolean") {
        return value;
      }

      if (value === 1 || value === "1") {
        return true;
      }

      if (value === 0 || value === "0") {
        return false;
      }

      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (normalized === "true") {
          return true;
        }
        if (normalized === "false") {
          return false;
        }
      }

      return fallback;
    },
    normalizeColumn(column) {
      const visible = this.toBoolean(column.visible, false);
      const exportVisibleRaw =
        column.export_visible === undefined || column.export_visible === null
          ? visible
          : column.export_visible;

      return {
        ...column,
        visible,
        export_visible: this.toBoolean(exportVisibleRaw, visible),
      };
    },
    loadFields(fields) {
      this.fields = fields;
    },
    onCancel() {
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", this.localColumns.map((c) => this.normalizeColumn(c)));
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cc-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.cc-modal {
  background: #ffffff;
  border-radius: 10px;
  max-width: 560px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.25);
}

.cc-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.cc-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.cc-body {
  padding: 0 20px 16px;
}

.cc-row {
  display: grid;
  grid-template-columns: 60px 1fr 90px 90px;
  align-items: center;
}

.cc-row-header {
  padding: 10px 0;
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
}

.cc-row-item {
  padding: 0px 0;
  border-bottom: 1px solid #f3f4f6;
}

.cc-col-order {
  display: flex;
  align-items: center;
}

.cc-col-label {
  display: flex;
  align-items: center;
}

.cc-col-visible {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 8px;
}

.cc-col-export {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 15px;
}

.cc-drag-handle {
  cursor: grab;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #9ca3af;
}

.cc-drag-handle:hover {
  color: #4b5563;
}

.cc-label-text {
  font-size: 11px;
  color: #111827;
}

.cc-list {
  max-height: 50vh;
  overflow-y: auto;
}

.cc-footer {
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cc-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}

.cc-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.cc-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #d1d5db;
  transition: 0.2s;
  border-radius: 999px;
}

.cc-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.25);
}

.cc-switch input:checked + .cc-slider {
  background-color: #2563eb;
}

.cc-switch input:checked + .cc-slider:before {
  transform: translateX(18px);
}

@media (max-width: 576px) {
  .cc-modal {
    max-width: 95vw;
  }
}
</style>
